import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageUtils } from '../../../../utils/image.utils';
import { CartUtils } from '../../../../utils/cart.utils';
import { UiUtils } from '../../../../utils/ui.utils';

@Component({
  selector: 'app-other-quote',
  templateUrl: './other-quote.component.html',
  styleUrls: ['./other-quote.component.scss'],
  standalone: false,
})
export class OtherQuoteComponent {
  @Input() loadingQuote!: boolean;
  @Input() currency!: string;
  @Input() quote: any;
  @Input() quoteImages!: any[];

  @Output() switchCartEmit: EventEmitter<{cartId: string, redirect: boolean}> = new EventEmitter<{cartId: string, redirect: boolean}>();
  @Output() deleteQuoteEmit: EventEmitter<{cartId: string, totalItemsQuantity: number}> = new EventEmitter<{cartId: string, totalItemsQuantity: number}>();

  quoteName: typeof CartUtils.getCartName = CartUtils.getCartName;
  singularOrPlural: typeof UiUtils.singularOrPlural = UiUtils.singularOrPlural;

  calculateEquType(details: any): number {
    const materialNumbers: string[] = [...new Set<string>(details.map((item: any) => item.attributes.systemDetails?.materialNumber))];
    return materialNumbers ? materialNumbers.length : 0;
  }

  getImageForQuote(itemId: string): string {
    return ImageUtils.getProductImageUrl(
      this.quoteImages.find(imageSet => imageSet.id === itemId)
    );
  }

  switchQuote(cartId: string, redirect?: boolean): void {
    this.switchCartEmit.emit({cartId, redirect: redirect ?? false});
  }

  deleteQuote(cartId: string, totalItemsQuantity: number): void {
    this.deleteQuoteEmit.emit({cartId, totalItemsQuantity});
  }
}
